import axios from "axios";

export async function getProducts(context, payload) {
  try {
    const { data } = await axios.get(`/product/get-by-project`, {
      params: payload,
    });
    if (data.error) {
      throw data;
    }

    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}

export async function getProductByName(context, payload) {
  try {
    const { data } = await axios.get(`/product/get-by-name`, {
      params: payload,
    });
    if (data.error) {
      throw data;
    }

    return data;
  } catch (e) {
    throw Error(e.response.data.message);
  }
}
